import {
  LOGIN_ROUTE,
  VERIFY_NUMBER_ROUTE,
  RECOVER_PASSWORD_ROUTE,
} from '../../providers/routes'
import { parseEnvFields } from '../../utils/utils'

const requiredUserFields = parseEnvFields(
  process.env.SESSION_REQUIRED_USER_FIELDS,
)

export const authStorageConfig = {
  name: 'adminAuthValidation',
  publicPaths: [
    '/',
    { path: LOGIN_ROUTE, exact: false },
    { path: VERIFY_NUMBER_ROUTE, exact: false },
    { path: RECOVER_PASSWORD_ROUTE, exact: false },
  ],
  storages: [
    {
      key: 'adminLoginUser',
      dataPath: 'user',
      tokenPath: 'token',
      requiredFields: requiredUserFields,
    },
  ],
  onFailure: {
    redirect: LOGIN_ROUTE,
  },
}

export default authStorageConfig
